/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import byId, * as fromById from './byId';

/* Helper function */
const updateActiveEdition = (editions, active, direction) => {
  const activeIndex = editions.findIndex(element => element === active);
  const length = editions.length;
  let next;

  if (direction === 'prev') {
    if (activeIndex < length - 1) {
      next = editions[activeIndex + 1];
    } else {
      next = editions[0];
    }
  }

  if (direction === 'next') {
    if (activeIndex === 0) {
      next = editions[length - 1];
    } else {
      next = editions[activeIndex - 1];
    }
  }
  return next;
};

/* Reducers */
const listByActive = (state = {
  active: 0,
  isFetching: false,
  all: [],
}, action) => {
  switch (action.type) {
    case 'REQUEST_EDITIONS':
      return {
        ...state,
        isFetching: true,
      };
    case 'RECIEVE_EDITIONS':
      // the response is sorted by year, newests -- oldest
      // initial active edition should be the newest which is @index 0.
      const active = action.edition ? action.edition : action.response[0].id;
      const all = action.response.map(edition => edition.id);
      return {
        ...state,
        active,
        isFetching: false,
        all,
      };
    case 'CHANGE_EDITION':
      const next = updateActiveEdition(state.all, state.active, action.direction);
      return { ...state, active: next };
    default:
      return state;
  }
};

const editions = combineReducers({
  byId,
  listByActive,
});

export default editions;

/* Selectors: */
export const getEdition = (state) => {
  const active = fromById.getEdition(state.byId, state.listByActive.active);
  return active || {};
};
export const getAllEditions = state =>
  state.listByActive.all.map(edition => fromById.getEdition(state.byId, edition));

export const getIsFetching = state => state.listByActive.isFetching;



// WEBPACK FOOTER //
// ./js/reducers/editions/index.js